// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"56b83655","787":"0fd54d5c"}[chunkId] + ".chunk.js";
};